import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import 'rxjs/add/operator/map';

import { Order } from '../models/order';
import { environment } from '../../environments/environment';

@Injectable()
export class OrderService {
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(private httpClient: HttpClient, private http: Http) {
  }

  saveOrder(order: Order): Observable<any> {
    return this.httpClient.post(environment.apiBaseUrl + '/orders/', JSON.stringify(order), {headers: this.headers});
  }

  getOrder(id: number): Observable<Order> {
    return this.httpClient.get<Order>(environment.apiBaseUrl + '/orders/' + id);
  }
}



// WEBPACK FOOTER //
// C:/Users/krist/source/repos/FoodButtler.App/src/app/services/order.service.ts